import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import frontend from "../../assets/image/Front-end Web Development Training - Certificate of Completion-1.png";
import backend from "../../assets/image/Back-end Web Development Training - Certificate of Completion-1.png";
import general from "../../assets/image/General Aptitude Training - Certificate of Completion-1.png";
import angular from "../../assets/image/Angular Training - Certificate of Completion-1.png";

const certificates = [
  {
    title: "General Aptitude",
    image: general,
    description:
      "The training consisted of Aptitude evaluation, Reading Comprehension, Quantitative Aptitude, Logical Reasoning, and Data Interpretation modules. In the final assessment, Parth scored 83% marks.",
  },
  {
    title: "Front-end Web Development",
    image: frontend,
    description:
      "The course consisted of Designing Static Pages using HTML, Styling Through CSS, Bootstrap The CSS Framework, and Making Web Pages Dynamic using JavaScript modules. Parth has scored 83% marks in the final assessment of this course",
  },
  {
    title: "Back-end Web Development",
    image: backend,
    description:
      "The course consisted of Developing the Backend Functionality via Node and Express, Connecting Frontend to Backend using React and RESTful APIs, Databases MongoDB and MySQL React Assignment, and E-commerce project modules. Parth has scored 77% marks",
  },
  {
    title: "Angular Training Certificate",
    image: angular,
    description:
      "The training consisted of Getting Started with Angular, Basics of Angular, Forms and Data Storage, Services and Pipes, Routing with Router Module, and Project Scribe modules. In the final assessment, Parth scored 80% marks",
  },
];

const CertificatePage = () => {
  return (
    <Container fluid className="bg-dark text-white py-5" id="certificate">
      <h1 className="display-1 text-center mb-5 font-weight-bold">
        My Certificates
      </h1>
      <Row className="g-4 justify-content-center">
        {certificates.map((cert, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3} className="d-flex">
            <Card className="w-100 shadow-sm border-0">
              <Card.Img variant="top" src={cert.image} alt={cert.title} />
              <Card.Body>
                <Card.Title>{cert.title}</Card.Title>
                <Card.Text>{cert.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default CertificatePage;
